<div id="plans-page" [ngStyle]="{'marginTop':( isDesktop$ ) ? '220px' : '40px'}">
    @let clientPlan = clientPlan$ | async;
    <header>
        <h1>
            <lucide-angular name="coins" size="44" strokeWidth="2"></lucide-angular>
            {{'nav.plans.title' | translate }}
        </h1>
        <h2>{{ clientPlan?.name }} Plan: Vous avez {{ tokensPerMonth$ | async }} tokens par mois</h2>
        <p>Besoin d'aide ? Pour obtenir de l'aide, résoudre des problèmes de tokens ou toute autre question, envoyez-nous un courriel à l'adresse suivante <a class="mailto"
                mailto="billing@;svet.com">billing&#64;svet.com</a> ou rendez-vous sur notre Discord.</p>
    </header>
    @defer (on viewport) {
    <app-pricing></app-pricing>
    } @placeholder {
    <div></div>
    }
    <p>Contactez-nous pour obtenir des montants de crédit personnalisés, des conditions commerciales, des compléments de prix, etc.</p>
</div>